import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="premium-preview"
export default class extends Controller {
  static targets = ["emptyState", "previewState", "toggleButton", "buttonText"]

  connect() {
    // Initialize with empty state visible
    this.showEmptyState()
  }

  togglePreview() {
    const isPreviewVisible = !this.previewStateTarget.classList.contains("hidden")

    if (isPreviewVisible) {
      this.showEmptyState()
    } else {
      this.showPreviewState()
    }
  }

  showEmptyState() {
    this.emptyStateTarget.classList.remove("hidden")
    this.previewStateTarget.classList.add("hidden")
    this.buttonTextTarget.textContent = "Prévisualiser avec données fictives"
  }

  showPreviewState() {
    this.emptyStateTarget.classList.add("hidden")
    this.previewStateTarget.classList.remove("hidden")
    this.buttonTextTarget.textContent = "Masquer l'aperçu"
  }
}
